import React from "react";
import { Box,Typography, Modal, Radio } from "@mui/material";
import { useDispatch,
  // useSelector
} from "react-redux";

import { connectWallet } from "../redux/WalletAction";
import {CgClose} from "react-icons/cg";
import { Stack } from "react-bootstrap";
import "./Connectwallet.css"
import metamask from "../Assets/Metamask.png";
import coinbase from "../Assets/Coinbase.png";
import walletconnect from "../Assets/WalletConnect.png";
import fortmatic from "../Assets/Formatic.png";


function ConnectWallet({ OpenWallet, setOpenWallet }) {

  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = React.useState("");
  const [selectedwallet, setSelectedwallet] = React.useState("");
  const handleChange = (event) => {
    setSelectedValue(event.title);
    setSelectedwallet(event.wallet);
  };

  const walletData = [
    {
      title: "Metamask",
      icon: metamask,
      wallet: "metamask",
    },
    {
      title: "Coinbase Wallet",
      icon: coinbase,
      wallet: "coinbasewallet",
    },
    {
      title: "WalletConnect",
      icon: walletconnect,
      wallet: "walletconnect",
    },
    {
      title: "Fortmatic",
      icon: fortmatic,
      wallet: "fortmatic",
    },
  ];

  const Connect = (walletname) => {
    setOpenWallet(false);
    dispatch(connectWallet(walletname));
  };

  return (
    <Box>
      <Modal  open={OpenWallet} onClose={() => setOpenWallet(false)} BackdropProps={{ style: { backgroundColor: "rgba(3,6,20,0.7)" , } }}>
        <Box className="modal-box">
          <div className="connectwallet_modal">
            <Box className="connect_header">
              <Typography variant="h6" className="walletTitle">
                Connect Wallet
              </Typography>
              <CgClose size={25} onClick={() => setOpenWallet(false)} style={{cursor:"pointer"}} />
            </Box>
            <Box className="itemContainer">
              {/* {cono} */}
              {walletData.map((item, index) => (
                <Box className={selectedValue==item.title?"bgchangedark":"radioContainer"} key={index}>
                  <Box className="radioTitle">
                    <img className="icons" src={item.icon} alt=""/>
                    <Typography variant="body1"  className={selectedValue==item.title?"colorchangepara":"titleverient"}>
                      {item.title}
                    </Typography>
                  </Box>
                  <Radio className="radionwalletconnect"
                    checked={selectedValue === item.title}
                    onChange={() => handleChange(item)}
                    value={item.title}
                    name="radio-buttons"
                    inputProps={{ "aria-label": item.title }}
                    style={{border:".5px solid white!important"}}
                  />
                </Box>
              ))}
            
            </Box>
            <Stack gap={3} className="d-flex justify-content-center align-items-center">
              <button
                className="poc_gradient-btn  border"
                onClick={() => {Connect(selectedwallet)}}
              >
                Connect Wallet
              </button>
            </Stack>
          </div>
        </Box>
      </Modal>
    </Box>
  );
}

export default ConnectWallet;
